import React from "react";
// import "./App.responsiveclaudecheck.css"
// import "./styleupdated2final3.css"
import "./style12.css"
// import "./style5-rendering-match-v2.css";

import { useEffect } from "react";
import { SectorProvider } from "./components/SectorContext";
import useParallax from "./components/useParallax";
import AppContent from "./components/AppContent";
import Lenis from "@studio-freight/lenis";
import ValentinoLogo from "./components/ValentinoLogo.jsx";
import { useState } from "react";

function App() {
  // useParallax();
  // Splash screen state determines whether the splash screen is shown or not. It is initially set to true if the user has not seen the splash screen in the current session.
  const [showSplash, setShowSplash] = useState(
    () => !sessionStorage.getItem("splashShown"),
  );

  // If the splash screen is shown, do nothing.
  useEffect(() => {
    if (!showSplash) return;

    // sessionStorage remembers whether the visitor has already seen the splash during the current browser tab/session.  For 2.3seconds, the splash screen is shown. After that period  it is hidden and remembered in sessionStorage.
    const timer = setTimeout(() => {
      setShowSplash(false);
      sessionStorage.setItem("splashShown", "true");
    }, 2300);

    return () => clearTimeout(timer);
  }, [showSplash]);

  // Manages weighted scrolling for the entire app using Lenis library.
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
    });

    let animationFrame;

    // update the animation frame for Lenis scrolling
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(animationFrame);
      lenis.destroy();
    };
  }, []);


  

  return (
    <SectorProvider>
      {showSplash && (
        <div className="splash-screen">
          <ValentinoLogo className="splash-logo cyber-accent" />
        </div>
      )}
      <AppContent />
    </SectorProvider>
  );
}

export default App;